import { Replanificacion } from "../TypesSolicitudVacaciones";

export function SumDiasOrdinariosReplanificaciones(obj: Replanificacion[]): number {
    let sum = 0;

    for (let index = 0; index < obj.length; index++) {
        const element = obj[index];
        sum += element.diasOrdinarios;
    }

    return sum;
}